import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { EMPTY, Observable, of } from "rxjs";
import { filter, tap } from "rxjs";
import { ErrorCode } from "@root/config";
import { StoreService } from "../service/store.service";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private store: StoreService,
    private router: Router,
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url;
    return next.handle(req).pipe(
      filter((event) => event instanceof HttpResponse),
      tap((event: HttpResponse<any>) => {
        if (!event.body) {
          return EMPTY;
        }
        const needAuth = req.headers.get("hostex-need-auth");
        // const hideError = req.headers.get("hostex-hide-error");
        if (needAuth === "no") {
          return of(event);
        }

        if (event.body.error_code === ErrorCode.AuthFailed) {
          this.store.clear();
          if (location.pathname !== "/app/login") {
            this.router.navigate(["/app/login"], {
              queryParams: { page_type: "register", redirect: location.pathname + location.search },
            });
          }
        } else if (event.body.error_code === ErrorCode.PlanExpired) {
          if (!this.inMemberBlackList(url)) {
            this.router.navigate(["/app/properties"]);
          }
        }
      }),
    );
  }

  inErrorAlertWhiteList(url) {
    const whiteUrls = ["/api/reservation/widget", "/api/thirdparty/account_login"];

    return whiteUrls.includes(url);
  }

  inMemberBlackList(url) {
    const blackUrls = [
      "/api/reservation/widget",
      "/api/calendar/holiday",
      "/api/calendar/quick_location_date",
      "api/stat/v2/transaction/detail_list",
      "api/stat/v2/transaction/operator_name_list",
      "api/transaction/get_currency",
      "api/house_relation/thirdparty_house_list",
      "api/house_relation/hostex_list",
      "api/calendar/quote",
      "/api/sub_account/list",
      "/api/role/list",
    ];

    return blackUrls.includes(url);
  }
}
